import React from 'react';
import { Row, Col } from 'react-bootstrap';

const CurrentTitleTab = ({ title, customStyle = {} }) => (
  <Row>
    <Col
      style={{
        backgroundColor: '#29b48f',
        textAlign: 'center',
        paddingTop: 5,
        paddingBottom: 5,
        marginTop: 5,
        marginBottom: 5,
        width: '100%',
        ...customStyle
      }}
    >
      <p className="mb-0" style={{ color: 'white', fontSize: 14, fontWeight: 'bold' }}>
        {title}
      </p>
    </Col>
  </Row>
);

export default CurrentTitleTab;
